import { io } from "socket.io-client";
import { SERVER_BASE_URL, IS_PRODUCTION } from './utils/constants'

const SOCKET_PATH = IS_PRODUCTION
  ? "/server/socket.io"
  : "/socket.io";

export const socket = io(SERVER_BASE_URL, {
  path: SOCKET_PATH,
  autoConnect: false,
  transports: IS_PRODUCTION ? ["polling", "websocket"] : ["websocket", "polling"],

  // Allow Socket.IO to select polling or WebSocket.
  // Do not force WebSocket during initial development.
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  timeout: 10000,
});